import * as Sentry from '@sentry/react';
import { redactPiiFromSentryEvent } from './pii-redactor';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const SENTRY_ENVIRONMENT =
  (import.meta.env.VITE_ENV as string | undefined) ??
  (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) ??
  'development';
const SENTRY_ENABLED = (import.meta.env.VITE_SENTRY_ENABLED as string | undefined) !== 'false';
const RELEASE =
  (import.meta.env.VITE_RELEASE as string | undefined) ?? import.meta.env.VITE_APP_VERSION;

export function initializeSentry(): void {
  if (!SENTRY_ENABLED || !SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: RELEASE,
    tracesSampleRate: SENTRY_ENVIRONMENT === 'production' ? 0.2 : 1,
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      return redactPiiFromSentryEvent(event);
    },
  });

  Sentry.setContext('app', {
    name: 'admin-panel',
    environment: SENTRY_ENVIRONMENT,
    release: RELEASE ?? 'unknown',
  });

  Sentry.addBreadcrumb({
    category: 'app.lifecycle',
    message: 'Sentry initialized',
    level: 'info',
    data: { environment: SENTRY_ENVIRONMENT, release: RELEASE ?? 'unknown' },
  });
}

export { Sentry };
